import { fetchBookingData, postBooking } from "../data/apiClient";

export const bookingRepository = {
    getBookingData: async () => {
        const response = await fetchBookingData();
        const bookingData = response.data;
        return bookingData;
    },

    postBooking: async (formBody) => {
        try {
            const response = await postBooking(formBody);
            return { success: response.status === 200 };
        } catch (error) {
            return { success: false, message: 'Something went wrong' };
        }
    }
}